import React, { useEffect, useState } from "react";
import axios from "axios";
import Button from "../../components/button/Button.jsx";
import BlogCard from "../../components/blogCard/BlogCard";
import EventNews from "../../components/eventNews/EventNews";
import { NavLink } from "react-router-dom";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import BlogImage from "../../assets/blogImage.png";
import "./blogs.css";

const Blogs = () => {
  const [activeIndex, setActiveIndex] = useState(0); // State to track the active button
  const [blogs, setBlogs] = useState([]); // Store blogs of the selected category
  const [mainTitle, setMainTitle] = useState("");
  const [mainImgUrl, setMainImgUrl] = useState("");
  const [excert, setExcert] = useState("");
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null); // eslint-disable-next-line no-unused-vars
  const [readTime, setReadTime] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [blogId, setBlogId] = useState(null);
  const [page, setPage] = useState(1);
  const [url, setUrl] = useState("");

  // Pagination state
  const [ setCurrentPage] = useState(1);
  // const itemsPerPage = 6;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://blog.giftcard8.com/wp-json/wp/v2/posts?page=${page}&per_page=6`
        );
        if (response.data.length > 0) {
          setBlogs(response.data);
          setBlogId(response.data[0].id);
          setMainTitle(response.data[0].title.rendered);
          setMainImgUrl(response.data[0].yoast_head_json.og_image[0].url);
          setExcert(response.data[0].excerpt.rendered);
          setCategoryId(response.data[0].categories[0]);
          setUrl(removeBaseUrl(response.data[0].link));
          setReadTime(`
            ${response.data[0].yoast_head_json.twitter_misc["Est. reading time"]} read
          `);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://blog.giftcard8.com/wp-json/wp/v2/categories"
        );
        if (response.data.length > 0) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchCategories();
  }, [page]);

  useEffect(() => {
    const fetchNextData = async () => {
      try {
        const response = await axios.get(
          `https://blog.giftcard8.com/wp-json/wp/v2/posts?page=${page}&per_page=6`
        );
        if (response.data.length > 0) {
          setBlogs(response.data);
        } else {
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchNextData();
  }, [page]);

  const fetchCategoriesBlogs = async (id) => {
    try {
      const response = await axios.get(
        `https://blog.giftcard8.com/wp-json/wp/v2/posts?categories=${id}`
      );
      if (response.data.length > 0) {
        setBlogs(response.data); // Update blogs based on category ID
        setCurrentPage(1); // Reset pagination to first page when category changes
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function removeBaseUrl(url) {
    const baseUrl = "https://blog.giftcard8.com/blog/";
    return url.startsWith(baseUrl) ? url.slice(baseUrl.length) : url;
  }
  const handleNext = () => {
    // if (currentPage < Math.ceil(blogs.length / itemsPerPage)) {
    //   setCurrentPage(currentPage + 1);
    // }
    setPage((prevPage) => prevPage + 1);
  };

  const handleButtonClick = (index, id) => {
    setActiveIndex(index);
    setCategoryId(id);
    fetchCategoriesBlogs(id);
  };

  const handleBack = () => {
    // if (currentPage > 1) {
    //   setCurrentPage(currentPage - 1);
    // }
    setPage((prevPage) => prevPage - 1);
  };

  const formatSlug = (slug) => {
    return slug
      .replace(/-/g, " ") // Replace hyphens with spaces
      .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize the first letter of the first word
  };
  // const indexOfLastBlog = currentPage * itemsPerPage;
  // const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  return (
    <>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div
        className="container d-flex flex-column justify-content-center align-items-center blgSection1"
        style={{ marginTop: "120px" }}
      >
        <span
          className="fw-bold rounded-4 fs-6 badge bg-light text-dark d-flex align-items-center mb-3"
          style={{ fontSize: "12px" }}
        >
          <i className="bi bi-dot" style={{ fontSize: "20px" }}></i>
          {readTime}
        </span>

        {/* Skeleton loader for main title */}
        {loading ? (
          <div
            className="skeleton-title"
            style={{
              width: "80%",
              height: "40px",
              backgroundColor: "#e0e0e0",
              marginBottom: "20px",
            }}
          ></div>
        ) : (
          <h3 className="fw-bold text-center">{mainTitle}</h3>
        )}

        {/* Skeleton loader for image */}
        {loading ? (
          <div
            className="skeleton-image"
            style={{
              width: "80%",
              height: "400px",
              backgroundColor: "#e0e0e0",
              borderRadius: "15px",
              marginBottom: "20px",
            }}
          ></div>
        ) : (
          <img
            src={mainImgUrl}
            alt="Main blog visual"
            className="rounded-5 my-4 img-fluid hover-effect blogImg"
            style={{ width: "75%", height: "400px", objectFit: "cover" }}
          />
        )}

        {/* Skeleton loader for content paragraph */}
        {loading ? (
          <div
            className="skeleton-content"
            style={{
              width: "75%",
              height: "100px",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              marginBottom: "20px",
            }}
          ></div>
        ) : (
          <p
            className="text-center w-75 text-muted fs-5 main_blogs_content"
            dangerouslySetInnerHTML={{ __html: excert }}
          ></p>
        )}

        <NavLink
          to={`/blog/${url}`}
          className="w-100"
          style={{ textDecoration: "none" }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-center align-items-center mb-5 contBtnDiv">
            <Button
              className="responsive-button hover-effect contBtn"
              style={{
                background: "transparent",
                border: "1px solid #5D5D5D",
                color: "#000",
                width: "15%",
              }}
              id="continueReadingBtn"
            >
              Continue Reading
            </Button>
          </div>
        </NavLink>
      </div>

      <div className="my-5">
        <div
          className="container d-flex justify-content-center mt-4 blgSection"
          style={{ width: "100%" }}
        >
          <div className="row flex-wrap g-2 p-1">
            {categories.map((category, index) => (
              <div
                className="col-3 col-sm-2 col-md-2 d-flex justify-content-center my_button"
                key={index}
              >
                <Button
                  onClick={() => handleButtonClick(index, category.id)}
                  className={`w-100 d-flex justify-content-center align-items-center fw-bold py-4 hover-effect ${
                    index === activeIndex ? "active-button" : "hover-button"
                  }`}
                  style={{
                    background: index === activeIndex ? "#000" : "#EEEEEE", // Different background for active button
                    color: index === activeIndex ? "#fff" : "#000", // Different color for active button
                    fontSize: "12px",
                    height: "30px",
                  }}
                  id={`categoryButton-${index}`}
                >
                  {formatSlug(category.slug)}
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className="container blgSection" style={{ width: "86%" }}>
          <h1 className="text-center my-5 fw-bold">Check out More Blogs</h1>
          <div className="row flex-wrap g-4 blogCards">
            {blogs.map((blog, index) => (
              <div className="col-6 col-lg-4 col-md-6 col-sm-6" key={index}>
                <BlogCard
                  title={blog.title.rendered}
                  img={blog.yoast_head_json?.og_image?.[0]?.url || BlogImage}
                  excert={blog.excerpt.rendered}
                  publishTime={blog.yoast_head_json.article_published_time}
                  url={removeBaseUrl(blog.link)}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="container">
          <div className="row my-4 d-flex justify-content-between">
            <div className="w-25 col-auto blogBtnBack d-flex justify-content-start align-items-start">
              <Button
                className="w-75 border hover-effect "
                style={{
                  background: "transparent",
                  color: "#000",
                }}
                onClick={handleBack}
                disabled={page <= 1}
                id="backBtn"
              >
                ← Back
              </Button>
            </div>
            <div className="w-25 col-auto blogBtnNext d-flex justify-content-end align-items-end">
              <Button
                className="w-75 border hover-effect"
                style={{
                  background: "transparent",
                  color: "#000",
                }}
                onClick={handleNext}
                id="nextBtn"
              >
                Next →
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5 blgSection" style={{ width: "86%" }}>
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
        <EventNews />
      </div>
    </>
  );
};

export default Blogs;
